import { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { heroSlides } from "../data/mock";

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 7000);
    return () => clearInterval(t);
  }, []);

  const slide = heroSlides[idx];

  return (
    <section className="relative h-screen min-h-[720px] w-full overflow-hidden bg-[#0A3161]">
      {/* Image layers */}
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-[1600ms] ease-in-out ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={s.image}
            alt=""
            className={`w-full h-full object-cover ${i === idx ? "slow-zoom" : ""}`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A3161]/70 via-[#0A3161]/50 to-[#0A3161]/90" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,rgba(10,31,61,0.6)_100%)]" />
        </div>
      ))}

      {/* Grain overlay */}
      <div className="absolute inset-0 grain opacity-40" />

      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
          <div className="max-w-4xl">
            <div key={idx} className="flex items-center gap-4 mb-8 fade-up">
              <div className="h-px w-16 bg-[#FFFFFF]" />
              <span className="font-condensed uppercase tracking-[0.35em] text-[#FFFFFF] text-xs">
                {slide.tag}
              </span>
            </div>

            <h1
              key={`t-${idx}`}
              className="fade-up-2 font-display text-white text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight"
            >
              {slide.title}
            </h1>

            <p
              key={`s-${idx}`}
              className="fade-up-3 mt-6 font-display text-[#FFFFFF] text-2xl md:text-3xl italic"
            >
              {slide.subtitle}
            </p>

            <div className="fade-up-4 mt-12 flex flex-wrap gap-4">
              <Link
                to="/membership"
                className="group inline-flex items-center gap-3 bg-[#B22234] hover:bg-[#8f1b2a] text-white px-8 h-14 font-condensed uppercase tracking-widest text-sm transition-colors"
              >
                Join Our Mission
                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/activities"
                className="group inline-flex items-center gap-3 border border-[#F5F5F7]/30 hover:border-[#FFFFFF] hover:text-[#FFFFFF] text-white px-8 h-14 font-condensed uppercase tracking-widest text-sm transition-colors backdrop-blur-sm"
              >
                Our Activities
                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-10 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
          <div className="flex gap-3">
            {heroSlides.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-[3px] transition-all duration-500 ${
                  i === idx ? "w-16 bg-[#FFFFFF]" : "w-8 bg-white/30"
                }`}
                aria-label={`slide ${i + 1}`}
              />
            ))}
          </div>
          <div className="hidden md:flex items-center gap-2 text-white/60">
            <span className="font-condensed uppercase tracking-widest text-xs">Scroll</span>
            <div className="w-px h-8 bg-white/40" />
          </div>
        </div>
      </div>
    </section>
  );
}
